import CreateSettingRequest from 'components/SettingRequest/CreateSettingRequest';
import { Routes, Route } from 'react-router-dom';
import NavigateBack from 'components/NavigateBack';

const SettingRequests = () => {
  return (
    <>
      <Routes>
        <Route
          path="new/:settingName"
          element={<CreateSettingRequest kind={'experience'} />}
        />
        <Route path="new/" element={<NavigateBack />} />
        <Route path="/" element={<NavigateBack />} />
      </Routes>
    </>
  );
};

export default SettingRequests;
